export default __webpack_public_path__ + "static/media/four.edd9bfb5.png";